export default "__VITE_ASSET__9ea1ee81__"